/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs';

import { Gallery } from '../model/gallery';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable()
export class FrontGalleriesService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   *
   * Get gallery by ID
   * @param id_or_seo Gallery ID or SEO URL
   * @param is_legacy_url Is Pixsell legacy URL
   * @param source Source of this product, Pixsell itself or external source like THP.
   * @param page Pagination page
   * @param page_size Items per page
   * @param current_product_id Since we can&#x27;t display the whole gallery it would make sense if we displayed the previous and the next items.
   * @param sort_ascending Should the gallery be sorted ascending or not, default ascending. This is important cause pagination.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public frontGetGallery(
    id_or_seo: string,
    is_legacy_url?: boolean,
    source?: string,
    page?: number,
    page_size?: number,
    current_product_id?: string,
    sort_ascending?: boolean,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Gallery>;
  public frontGetGallery(
    id_or_seo: string,
    is_legacy_url?: boolean,
    source?: string,
    page?: number,
    page_size?: number,
    current_product_id?: string,
    sort_ascending?: boolean,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Gallery>>;
  public frontGetGallery(
    id_or_seo: string,
    is_legacy_url?: boolean,
    source?: string,
    page?: number,
    page_size?: number,
    current_product_id?: string,
    sort_ascending?: boolean,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Gallery>>;
  public frontGetGallery(
    id_or_seo: string,
    is_legacy_url?: boolean,
    source?: string,
    page?: number,
    page_size?: number,
    current_product_id?: string,
    sort_ascending?: boolean,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (id_or_seo === null || id_or_seo === undefined) {
      throw new Error(
        'Required parameter id_or_seo was null or undefined when calling frontGetGallery.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (is_legacy_url !== undefined && is_legacy_url !== null) {
      queryParameters = queryParameters.set(
        'is_legacy_url',
        <any>is_legacy_url
      );
    }
    if (source !== undefined && source !== null) {
      queryParameters = queryParameters.set('source', <any>source);
    }
    if (page !== undefined && page !== null) {
      queryParameters = queryParameters.set('page', <any>page);
    }
    if (page_size !== undefined && page_size !== null) {
      queryParameters = queryParameters.set('page_size', <any>page_size);
    }
    if (current_product_id !== undefined && current_product_id !== null) {
      queryParameters = queryParameters.set(
        'current_product_id',
        <any>current_product_id
      );
    }
    if (sort_ascending !== undefined && sort_ascending !== null) {
      queryParameters = queryParameters.set(
        'sort_ascending',
        <any>sort_ascending
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Gallery>(
      'get',
      `${this.basePath}/galleries/${encodeURIComponent(String(id_or_seo))}`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
